module.exports = __webpack_public_path__ + "media/customizations/vanmetre/logo-71d2149ae1e19ec145bd148ffdb217f0.png";